// Meta-data
export const META_GET_ALL  = 'OrganizationService/api/meta-data/get-all';
export const META_UPDATE  = 'OrganizationService/api/meta-data/update';
export const META_GET_DYNAMIC_FORM_FIELDS = 'OrganizationService/api/meta-data/get-dynamic-form-fields';

// RequestType
export const REQUEST_TYPE_GET_ALL_DROPDOWN = 'TimeManagementService/api/request-type/get-all-drop-down';

export const GET_ALL_TIMETABLES = 'TimeManagementService/api/Timetable/get-all'
export const SEARCH_TIMETABLES = 'TimeManagementService/api/Timetable/search';
export const GET_TIMETABLE_BY_ID = 'TimeManagementService/api/Timetable/get'; // append /{id} dynamically
export const CREATE_TIMETABLE = 'TimeManagementService/api/Timetable/create';
export const UPDATE_TIMETABLE = 'TimeManagementService/api/Timetable/update'; // append /{id} dynamically
export const DELETE_TIMETABLE = 'TimeManagementService/api/Timetable/delete'; // append /{id} dynamically
export const BULK_DELETE_TIMETABLE = 'TimeManagementService/api/Timetable/bulk-delete'; // append /{id} dynamically